<template>
  <div>
    <v-row>
        <v-col>
            <v-btn
                color="primary"
                dark
                @click="onAddOrgBtn"
            >
                Добавить организацию
            </v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
          <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" colspan="4">
                <v-text-field
                        label="Поиск"
                        v-model="orgSearch"
                ></v-text-field>
            </th>
          </tr>
          <tr>
            <th class="text-left">#</th>
            <th class="text-left">ИНН</th>
            <th class="text-left">Название</th>
            <th class="text-left">Действия</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(organization, index) in organizations"
            :key="organization.name"
          >
            <td>{{ pp + index + 1 }}</td>
            <td>{{ organization.inn }}</td>
            <td>{{ organization.short_name }}</td>
            <td>
              <v-btn v-if="organization.id !== ORGANIZATION_ID" @click="onCheckout(organization.id)">Переключиться</v-btn>
              <v-btn v-else
                disabled
                class="mx-2"
              >
                <v-icon
                  large
                  color="green darken-2"
                >
                  mdi-check-bold
                </v-icon>
                  Выбрано
                </v-btn>
              <v-btn
                v-if="IS_OWNER"
                color="error" depressed @click="() => $emit('on-click-remove', organization)"
              >Удалить</v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
    name: 'OrganizationList',
    props:{
        organizations: Array,
        pp: {
            type: Number,
            default: 0
        }
    },
    mounted(){
    },
    data(){
      return {
          orgSearch: ''
      }
    },
    watch:{
        orgSearch: function (v) {
            this.$emit('search', v);
        }
    },
    methods: {
      ...mapActions('workspace', ['CHECKOUT_ORGANIZATION']),
        onAddOrgBtn(){
            this.$router.push({name: 'OrganizationAdd'})
        },
        async onCheckout(id){
          await this.CHECKOUT_ORGANIZATION(id);
        }
    },
    computed: {
        ...mapGetters('workspace', ['ORGANIZATION_ID', 'IS_OWNER']),
    }
}
</script>